import * as navigation from 'Navigation';

export default class ProcessFlowchartTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Flowchart',
      closeable: false,
      preferenceKey: 'process-flowchart',
    };
  }
}
